(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!window.stripeProductCheckoutBound) {
    window.stripeProductCheckoutBound = true;
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-stripe-product-checkout]');
      if (!button) return;
      const form = document.getElementById(button.dataset.formId);
      const variantInput = form?.querySelector('[name="id"]');
      const quantityInput = form?.elements.namedItem('quantity');
      const original = button.textContent;
      const wrapper = button.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
      const message = wrapper?.querySelector('.product-form__error-message');
      button.disabled = true;
      button.textContent = button.dataset.loadingLabel;
      if (wrapper) wrapper.hidden = true;
      try {
        if (!variantInput?.value) throw new Error(button.dataset.errorLabel);
        const quantity = Number(quantityInput?.value || 1);
        const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error(button.dataset.errorLabel);
        const cart = await cartResponse.json();
        const response = await fetch(button.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            cartToken: cart.token,
            items: [{ variantId: String(variantInput.value), quantity }]
          })
        });
        const result = await response.json();
        if (!response.ok || !result.url) throw new Error(result.error || button.dataset.errorLabel);
        window.location.assign(result.url);
      } catch (error) {
        if (message) message.textContent = error.message || button.dataset.errorLabel;
        if (wrapper) wrapper.hidden = false;
        button.disabled = false;
        button.textContent = original;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
